let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cFQie")).then(() => parcelRequire('iOPQr'));